// 카카오 디벨로퍼스 앱 "플랫폼 → Web 도메인" 에 https://dev-rest.housedeal.co.kr 화이트리스트 필요.
// JS appkey 는 public(브라우저 노출) — 도메인 화이트리스트로 통제.
export const environment = {
  production: false,
  apiUrl: 'https://dev-rest.housedeal.co.kr/api',
  authBaseUrl: 'https://dev-rest.housedeal.co.kr',
  kakaoJsKey: 'dd6d30c4fc2cb51f38bc0c33c9bfcfa1',
};
